import Swiper from 'swiper';
import 'swiper/css';

const Patrocinadores = () => {
    const components = document.querySelectorAll('[data-component="patrocinadores"]');

    components.forEach(component => {
        console.log('Iniciando componente Patrocinadores');
        const swiperComponent = component.querySelector('.swiper');

        const swiper = new Swiper(swiperComponent, {
            loop: false,
            slidesPerView: "auto",
            spaceBetween: 50,
            breakpoints: {
                0: {
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                },
                1280: {
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 100,
                }
            }
        });
    });
};

export default Patrocinadores;

if(document.querySelectorAll('[data-component="patrocinadores"]').length) {
    Patrocinadores();
}